module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/team/teachers/olha-3f0df9e5a81cc0f2be21a28bffe1c5d3.webp";